<template>
    <section class="position-relative feature-section ptb-100" v-bind:class="{ 'gray-light-bg' : isGray }">
        <div class="container">
            <div
                class="row align-items-center justify-content-between justify-content-sm-center justify-content-md-center">
                <div class="col-sm-5 col-md-6 col-lg-6 mb-5 mb-md-5 mb-sm-5 mb-lg-0">
                    <div class="download-img">
                        <img src="../../assets/img/about-us.png" alt="download" class="img-fluid" />
                    </div>
                </div>
                <div class="col-md-12 col-lg-6">
                    <div class="feature-contents">
                        <h2>From A to B with BBR</h2>
                        <!--<p>
                            Objectively deliver professional value with diverse web-readiness.
                            Collaboratively transition wireless customer service without goal-oriented catalysts for
                            change. Collaboratively.
                        </p>
                        <p>Uniquely simplify sustainable applications whereas adaptive schemas. Competently brand performance based content and.</p>-->
                        <ul class="dot-circle pt-2">
                            <b>WHERE TO:</b>
                            <li>Enter your pick-up and drop-off locations to get your estimated fare.</li>
                            <b>CHOOSE THE RIDE</b>
                            <li>We have a range of cars available for any price point. (Economy, Comfort or Business).</li>
                            <b>YOU'RE ON YOUR WAY:</b>
                            <li>Tap “book” and track your driver's real-time location. Check the details of your ride before getting in.</li>
                        </ul>

                        <div class="action-btns mt-4">
                            <a href="#" class="btn btn-brand-02 mr-3">Get Start Now</a>
                            <a href="#" class="btn btn-outline-brand-02">More About Us</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>


<script>
    export default {
        name: 'SharePhotos',
        props: {
            isGray: {
                type: Boolean,
                default: false
            }
        }
    }
</script>